<a class="course-template-card" [routerLink]="[baseUrl, template?.slug]">
    <div ngImagePixel #LargeImageHolder="imagePixel" class="thumbail-img">
        <img class="card-image-top" [alt]="template.title" src="{{
            getDefaultImage(template?.media)
          }}?{{LargeImageHolder.getImagePixel()}}&fit=crop" alt="Card image cap" />
    </div>
    <div class="course-template-card-body">
        <div class="template-title-section py-2">
            <h5 class="template-title m-0 text-truncate">{{template?.title}}</h5>
        </div>
        <div class="template-info-section pb-2">
            <div class="template-duration-section pr-2">
                <div class="section-title">{{translationScope+'.duration' | transloco}}</div>
                <div class="duration section-content">{{template?.duration}} {{translationScope + (isSingular(template?.duration) ? '.hour': '.hours') | transloco}}</div>
            </div>
            <div class="template-available-courses-section">
                <div class="section-title">{{translationScope+'.availableCourses' | transloco}}</div>
                <div class="available-courses-no section-content">{{template?.availableSlots}}</div>
            </div>
        </div>
        <div class="template-description-section pb-3">
            <div class="section-title">{{translationScope+'.description' | transloco}}</div>
            <div class="section-content template-description" [innerHTML]="template.cardInfo | stripHtmlCode"></div>
        </div>
    </div>
</a>
